/**
 * 开发组枚举值
 */
export const developerGroups = ['product', 'design', 'frontend', 'backend', 'testing'];
/**
 * 开发组中文标签
 */
export const DEVELOPER_GROUP_LABELS = {
    product: '产品组',
    design: '美术组',
    frontend: '前端组',
    backend: '后端组',
    testing: '测试组',
};
/**
 * 职能角色枚举值
 */
export const functionRoles = ['finance', 'hr', 'admin'];
/**
 * 职能角色中文标签
 */
export const FUNCTION_ROLE_LABELS = {
    finance: '财务',
    hr: '人事',
    admin: '行政',
};
/**
 * 团队成员类型枚举值
 */
export const memberTypes = ['owner', 'function', 'developer'];
//# sourceMappingURL=developer.js.map